import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useCallback, useEffect, useRef, useState } from 'react';
import EventEmitter from 'events';
import { isMobile } from '../../utils';
import Video from 'twilio-video';
export default function useRoom(localTracks, options) {
  var _useState = useState(new EventEmitter()),
      room = _useState[0],
      setRoom = _useState[1];

  var _useState2 = useState(false),
      isConnecting = _useState2[0],
      setIsConnecting = _useState2[1];

  var optionsRef = useRef(options);
  var activeRoom = useRef(null);
  useEffect(function () {
    // This allows the connect function to always access the most recent version of the options object. This allows us to
    // reliably use the connect function at any time.
    optionsRef.current = _extends({}, options, {
      tracks: localTracks
    });
  }, [options, localTracks]);
  useEffect(function () {
    return disconnect;
  }, []);
  var connect = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token, onConnect, onDisconnect) {
      var newRoom;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsConnecting(true);
              _context.prev = 1;
              _context.next = 4;
              return Video.connect(token, optionsRef.current);

            case 4:
              newRoom = _context.sent;
              setRoom(newRoom);
              activeRoom.current = newRoom;
              newRoom.once('disconnected', function () {
                // Reset the room only after all other `disconnected` listeners have been called.
                setTimeout(function () {
                  setRoom(new EventEmitter());
                  activeRoom.current = null;
                });
                onDisconnect && onDisconnect();
              });
              newRoom.localParticipant.videoTracks.forEach(function (publication) {
                return (// All video tracks are published with 'low' priority because the video track
                  // that is displayed in the 'MainParticipant' component will have it's priority
                  // set to 'high' via track.setPriority()
                  publication.setPriority('low')
                );
              });
              onConnect && onConnect();
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              throw _context.t0;

            case 15:
              _context.prev = 15;
              setIsConnecting(false);
              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12, 15, 18]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(), [localTracks]);
  var republishTracks = useCallback(function () {
    if (room === null || room === void 0 ? void 0 : room.localParticipant) {
      for (var _iterator = _createForOfIteratorHelperLoose(room.localParticipant.tracks), _step; !(_step = _iterator()).done;) {
        var _step$value = _step.value,
            trackSid = _step$value[0],
            publication = _step$value[1];
        publication.unpublish();
        room.localParticipant.emit('trackUnpublished', publication);
      }

      var _loop = function _loop() {
        var track = _step2.value;
        room.localParticipant.publishTrack(track, {
          priority: track.kind === 'video' ? 'low' : 'standard'
        })["catch"](function (error) {
          return console.error('republihsing ERROR', track.kind, error);
        });
      };

      for (var _iterator2 = _createForOfIteratorHelperLoose(optionsRef.current.tracks), _step2; !(_step2 = _iterator2()).done;) {
        _loop();
      }
    }
  }, [room === null || room === void 0 ? void 0 : room.localParticipant, localTracks]);
  var disconnect = useCallback(function () {
    if (activeRoom.current) activeRoom.current.disconnect();
  }, []);
  return {
    room: room,
    isConnecting: isConnecting,
    connect: connect,
    disconnect: disconnect,
    republishTracks: republishTracks
  };
}